<template>
    <div v-if="shows" class="body-tool">
        <tool-prev v-model="items[index - 1]" />
        <tool-this v-model="items[index]" @input="emit" />
        <tool-next v-model="items[index + 1]" />
    </div>
</template>

<script>
import { EMPLOYMENT_FIELD_SIDES, EMPLOYMENT_FIELD_TYPES } from "@/assets/variables";
import { mapState } from "vuex";

import ToolNext from "./tool/tool-next.vue";
import ToolPrev from "./tool/tool-prev.vue";
import ToolThis from "./tool/tool-this.vue";

export default {
    components: {
        ToolNext,
        ToolPrev,
        ToolThis,
    },
    props: {
        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },

        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentField[]>} */
        value: { type: Array, default: () => [] },
    },
    data: () => ({
        initiated: false,
        /** @type {import('@/assets/variables').EmploymentField[]} */
        items: [],
    }),
    computed: {
        shows() {
            if (this.mode != "sign") return false;
            return this.initiated;
        },

        ...mapState("employment/form/node", {
            index({ active }) {
                return this.items.findIndex((item) => item.tempId == active?.tempId);
            },
        }),
    },
    mounted() {
        this.init();
    },
    watch: {
        value() {
            this.init();
        },
    },
    methods: {
        init() {
            this.sync();

            if (this.mode != "sign") return;
            if (this.initiated) return;

            let item = this.items[0];
            if (!item) return;

            this.$store.commit("employment/form/node/setActive", item);
            this.initiated = true;
        },
        sync() {
            this.items = this.value.filter(({ side, type }) => side == EMPLOYMENT_FIELD_SIDES.EMPLOYEE.value && type != EMPLOYMENT_FIELD_TYPES.FILE.value);
        },
        emit() {
            let value = this.value.filter(({ side, type }) => side != EMPLOYMENT_FIELD_SIDES.EMPLOYEE.value || type == EMPLOYMENT_FIELD_TYPES.FILE.value);
            this.$emit("input", [...value, ...this.items]);
        },
    },
};
</script>

<style lang="scss" scoped>
.body-tool {
    position: absolute;
    right: 50%;
    bottom: 16px;
    transform: translateX(50%);

    display: flex;
    flex-direction: row;
    gap: 8px;
}
@media (min-width: 1024px) {
    .body-tool {
        right: 16px;
        bottom: 50%;
        transform: translateY(50%);

        flex-direction: column;
    }
}
</style>
